import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../../../theme";
import { useState, useEffect } from "react";
import useApi from "../../../shared/hooks/useApi";
import LoadingScreen from "../../../shared/components/LoadingScreen/LoadingScreen";
import ReactApexChart from 'react-apexcharts';
import { CustomInfoButton } from "../../components/infoButtons/CustomInfoButton";
import FilledOperationalModeChart from "./graphs/FilledOperationalModeChart";
// Define operational mode colors and labels


export default function GrootbijgaardenDashboard() {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [loading, setLoading] = useState(false);
    const [currentMode, setCurrentMode] = useState(null);
    const [chpData, setChpData] = useState(null);

    const {apiGet, apiPost} = useApi();

    useEffect(() => {
        const getData = async () => {
            const getDataRoute = `/esid-24-031/get-chp-data`;
            try {
                const data = await apiGet("UX_HTTP_API", getDataRoute);
                setChpData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        getData();

    }, []);

    // Update current mode based on time with gap handling
    useEffect(() => {
        // Only run this effect if chpData is available
        if (!chpData || !chpData.CHP || !chpData.CHP['CHP-01']) {
            return;
        }

        const updateCurrentMode = () => {
            const now = new Date();
            const chp01Data = chpData.CHP['CHP-01'];
            
            // Find the current mode by checking which datetime entry we're currently in
            const currentModeData = chp01Data.find(entry => {
                const entryTime = new Date(entry.datetime);
                const nextEntryIndex = chp01Data.indexOf(entry) + 1;
                
                if (nextEntryIndex < chp01Data.length) {
                    const nextEntryTime = new Date(chp01Data[nextEntryIndex].datetime);
                    return now >= entryTime && now < nextEntryTime;
                } else {
                    // For the last entry, check if we're after its time
                    return now >= entryTime;
                }
            });
            
            setCurrentMode(currentModeData?.value || null);
        };

        updateCurrentMode();
        const interval = setInterval(updateCurrentMode, 60000); // Update every minute

        return () => clearInterval(interval);
    }, [chpData]);

    return (
        <Box ml={"40px"} sx={{ justifyContent: "center", display: "flex" }}>
            <Box sx={{
                ml: 2,
                mr: 2,
                minHeight: window.innerHeight - 35,
                width: window.innerWidth,
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>
                {loading && <LoadingScreen loading={loading} />}

                <Box sx={{ mb: 2, width: '100%', display: 'flex', justifyContent: 'flex-start' }}>
         
                </Box>

                <Box sx={{ width: '100%', height: 400, mt: 2, mb: 2 }}>
                    <FilledOperationalModeChart chpData={chpData} />
                </Box>
            </Box>
        </Box>
    );
}